import { NavLink } from 'react-router-dom';

export default function Intro({ _data }) {
  return (
    <section class='industry-intro-section'>
      <div class='container'>
        <div class='row align-items-center'>
          <div class='col-lg-6'>
            <span class='intro-tagline'>{_data.tagline}</span>
            <h2 class='intro-heading'>{_data.heading}</h2>
            <p class='intro-description'>{_data.description}</p>
          </div>
          <div class='col-lg-6'>
            <div class='intro-image'>
              <img src={_data.img} alt='img' class='img-fluid rounded shadow' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
